var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teasers"},_vm._l((_vm.teasers),function(teaser,index){return _c('CmsTeaser',{key:index,attrs:{"block":teaser}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }